module.exports = __webpack_public_path__ + "static/logo_text-704d067a24a76ce61e8f05b9c361d7e2.png";